<template>
    <div class="box">
        <Titlebar
                :title="'激活货柜'"/>
        <video id="video" class="qrcode-video"/>
        <div class="note">
            1. 请先扫描主控二维码
        </div>
        <video-device-error placeholder="输入主控码" v-model="visible" prefix="https://machine.goldbox.vip/" @submit="onDecode"/>
    </div>
</template>

<script>


    import Titlebar from "./Titlebar.vue"
    import videoDeviceError from "./videoDeviceError";

    import {isBoxNumber, parseBoxNumber} from "../util/utils.js"
    import {scanQrCode} from '../util/qrcode.js';

    export default {
        name: 'BindScanDevice',
        data() {
            return {
                visible: false
            }
        },
        props: {},
        components: {
            Titlebar,
            videoDeviceError
        },
        mounted() {
            scanQrCode("video", this.onDecode, () => {
                this.visible = true;
            })
        },
        methods: {
            onDecode(boxNumber) {
                if (isBoxNumber(boxNumber)) {  //主控
                    var number = parseBoxNumber(boxNumber)
                    console.log(number)
                    var url = process.env.VUE_APP_API_SERVER + '/box/' + number + "/test-result"
                    var accessToken = localStorage.getItem('accessToken')

                    var that = this
                    fetch(url, {
                        method: "GET",
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Access-Token': accessToken
                        })
                    }).then(res => {
                        if (!res.ok) {
                            throw res
                        }
                        return res.json()
                    }).catch(error => {
                        sessionStorage.setItem("bindResult", "failed")
                        sessionStorage.setItem("bindResultFailedReason", error)
                        that.$router.go(-1)
                    }).then(response => {
                        if (response.Status == 0) {
                            if (response.Headers &&
                                response.Headers["X-Oss-Meta-Upload-Type"] &&
                                response.Headers["X-Oss-Meta-Upload-Type"].length > 0) {
                                if (response.Headers["X-Oss-Meta-Upload-Type"][0] == "normal") {
                                    sessionStorage.setItem("bindDeviceNumber", number)

                                    this.$router.push("/bindscancupboard")
                                } else {
                                    sessionStorage.setItem("bindFailedUploadStatus", response.Headers["X-Oss-Meta-Upload-Type"][0])
                                    sessionStorage.setItem("bindFailedNumber", response.Tag)
                                    this.$router.push("/bindfailed")
                                }
                            } else {
                                sessionStorage.setItem("bindResult", "failed")
                                sessionStorage.setItem("bindResultFailedReason", "没有发现视频的头信息")
                                this.$router.go(-1)
                            }
                        } else {
                            sessionStorage.setItem("bindFailedStatus", response.Status)
                            sessionStorage.setItem("bindFailedNumber", response.Tag)
                            this.$router.push("/bindfailed")
                        }
                    })
                } else {
                    sessionStorage.setItem("bindResult", "failed")
                    sessionStorage.setItem("bindResultFailedReason", "主控码无效")
                    this.$router.go(-1)
                }

            }
        }
    }
</script>

<style scoped>
    .note {
        margin-top: 20px;
        font-size: 20px;
        color: #666;
    }

    .box {
        width: 100%;
        height: 100%;
    }

    .qrcode-video {
        width: 100%;
        height: 50%;
        background-color: black;
    }
</style>
